import { GAME_NAME } from "../../../../common/constants.ts";
import { i18n } from "../util/useT.ts";

export const LeagueNotFoundMessage = () => {
	const pro = "NBA";
	const sport = i18n.t(`sport.${process.env.SPORT}`, {
		ns: "ui",
		defaultValue: process.env.SPORT,
	});
	const values = {
		gameName: GAME_NAME,
		pro,
		sport,
	};

	return (
		<section
			aria-labelledby="league-not-found-title"
			data-league-not-found-recovery=""
			data-league-not-found-state="missing"
		>
			<h2 id="league-not-found-title" data-league-not-found-title="">
				{i18n.t("leagueNotFound.title", {
					ns: "ui",
					defaultValue: "League not found",
				})}
			</h2>
			<div className="my-5 text-center" data-league-not-found-actions="">
				<h3>
					{i18n.t("leagueNotFound.playNow", {
						ns: "ui",
						defaultValue: "Play {{gameName}} now!",
						gameName: GAME_NAME,
					})}
				</h3>
				<a
					href="/new_league"
					className="btn btn-success btn-lg m-2"
					data-league-not-found-recovery-action="new-league"
				>
					{i18n.t("leagueNotFound.createNewLeague", {
						ns: "ui",
						defaultValue: "Create a new league",
					})}
				</a>
				<span className="d-none d-sm-inline me-5" />
				<a
					href="/"
					className="btn btn-primary btn-lg m-2"
					data-league-not-found-recovery-action="dashboard"
				>
					{i18n.t("leagueNotFound.loadExistingLeague", {
						ns: "ui",
						defaultValue: "Load an existing league",
					})}
				</a>
			</div>
			<div className="row">
				<div className="col-md-6">
					<h3>
						{i18n.t("leagueNotFound.newToGame", {
							ns: "ui",
							defaultValue: "New to {{gameName}}?",
							gameName: GAME_NAME,
						})}
					</h3>
					<p>
						{i18n.t("leagueNotFound.intro", {
							ns: "ui",
							defaultValue:
								"Have you ever looked at the decisions made by the front office of an {{pro}} team and thought you could do better? Well, now you can! In {{gameName}}, you are the general manager of a {{sport}} team.",
							...values,
						})}
					</p>
					<div className="row">
						<div className="col-sm-6 col-md-12 col-lg-6">
							<h3>
								{i18n.t("leagueNotFound.strategyTitle", {
									ns: "ui",
									defaultValue: "You Set The Strategy",
								})}
							</h3>
							<p>
								{i18n.t("leagueNotFound.strategyIntro", {
									ns: "ui",
									defaultValue:
										"Running a {{sport}} team requires you to make tough decisions.",
									sport,
								})}
							</p>
							<ol>
								<li>
									{i18n.t("leagueNotFound.strategyQ1", {
										ns: "ui",
										defaultValue:
											"Should you re-sign a veteran player, or leave cap space open to sign a free agent?",
									})}
								</li>
								<li>
									{i18n.t("leagueNotFound.strategyQ2", {
										ns: "ui",
										defaultValue:
											"Should you draft a raw player who could be a star, or someone who can contribute right away?",
									})}
								</li>
								<li>
									{i18n.t("leagueNotFound.strategyQ3", {
										ns: "ui",
										defaultValue:
											"Should you trade away next season's draft pick for a player who can help you win now, or stockpile assets for the future?",
									})}
								</li>
								<li>
									{i18n.t("leagueNotFound.strategyQ4", {
										ns: "ui",
										defaultValue:
											"Should you raise ticket prices and annoy your fans, or can you cut part of your budget instead?",
									})}
								</li>
							</ol>
							<p>
								{i18n.t("leagueNotFound.strategyOutro", {
									ns: "ui",
									defaultValue:
										"Make the right choices and you can build a dynasty. But make the wrong choices and you'll get fired!",
								})}
							</p>
						</div>
						<div className="col-sm-6 col-md-12 col-lg-6">
							<h3>
								{i18n.t("leagueNotFound.qualityTitle", {
									ns: "ui",
									defaultValue: "High Quality, No Junk",
								})}
							</h3>
							<p>
								{i18n.t("leagueNotFound.free", {
									ns: "ui",
									defaultValue:
										"{{gameName}} is completely 100% free. You can start as many leagues as you want and play as many seasons as you want. No limits.",
									gameName: GAME_NAME,
								})}
							</p>
							<p>
								{i18n.t("leagueNotFound.noJunk", {
									ns: "ui",
									defaultValue:
										"We won't ask for your email address and send you spam. We won't force you to sign in with your Facebook account and spam your friends. We won't ask you to pay money to keep playing or to buy game-breaking power-ups.",
								})}
							</p>
							<p>
								{i18n.t("leagueNotFound.goal", {
									ns: "ui",
									defaultValue:
										"Our only goal is making the best possible {{sport}} management game!",
									sport,
								})}
							</p>
						</div>
					</div>
				</div>
				<div className="col-md-6" data-league-not-found-diagnostic="">
					<h3>
						{i18n.t("leagueNotFound.expectingTitle", {
							ns: "ui",
							defaultValue: "Expecting to find a league here?",
						})}
					</h3>
					<p>
						{i18n.t("leagueNotFound.serverData", {
							ns: "ui",
							defaultValue:
								"Leagues are stored by the app server. If you expected a league here, go back to Leagues and open it from the list.",
						})}
					</p>
					<p>
						{i18n.t("leagueNotFound.missingServerLeague", {
							ns: "ui",
							defaultValue:
								"If the league is missing from the list too, it may have been deleted or this session may not have access to it.",
						})}
					</p>
				</div>
			</div>
		</section>
	);
};
